import { gql } from '@apollo/client';
import { AddressLocationReviewFiltersInput } from '../queries/getAddressLocationReviewListing';

/**
 * 按列表筛选条件同步导出 Excel：后端生成后上传对象存储，返回预签名下载 URL（不走下载中心 / 异步任务）。
 * 列与列表页一致。
 */
export const EXPORT_ADDRESS_LOCATION_REVIEWS = gql`
  mutation ExportAddressLocationReviews(
    $filters: AddressLocationReviewFiltersInput
    $language: String
    $timeZone: String
  ) {
    exportAddressLocationReviews(filters: $filters, language: $language, timeZone: $timeZone) {
      success
      code
      message
      downloadUrl
      recordCount
    }
  }
`;

export type AddressLocationReviewExportCode = 'SUCCESS' | 'NO_DATA' | 'EXCEED_MAX_LIMIT' | 'ERROR';

export interface AddressLocationReviewExportResultType {
  success: boolean;
  code: AddressLocationReviewExportCode | string;
  message: string;
  downloadUrl: string | null;
  recordCount: number | null;
}

export interface ExportAddressLocationReviewsResponse {
  exportAddressLocationReviews: AddressLocationReviewExportResultType;
}

export interface ExportAddressLocationReviewsVariables {
  filters?: AddressLocationReviewFiltersInput;
  language?: string;
  timeZone?: string;
}
